import { TelemetryDimensions } from './TelemetryConstants';

interface DeploymentTelemetryInput {
  entityType: string;
  entityCount: number;
  tenantIds: string[];
  batchId?: string | null;
}

export const createDeploymentTelemetryProperties = ({
  entityType,
  entityCount,
  tenantIds,
  batchId,
}: DeploymentTelemetryInput): Record<string, unknown> => {
  const uniqueTenantIds = Array.from(
    new Map(
      tenantIds
        .filter(Boolean)
        .map((tenantId) => [tenantId.toLowerCase(), tenantId]),
    ).values(),
  );

  return {
    [TelemetryDimensions.EntityType]: entityType.toUpperCase(),
    [TelemetryDimensions.EntityCount]: entityCount,
    [TelemetryDimensions.TenantCount]: uniqueTenantIds.length,
    ...(uniqueTenantIds.length === 1
      ? { [TelemetryDimensions.TenantId]: uniqueTenantIds[0] }
      : {}),
    ...(batchId ? { [TelemetryDimensions.DeploymentBatchId]: batchId } : {}),
  };
};
